import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ServicesPage from '../pages/services/page';
import TechnologyPage from '../pages/technology/page';
import FacilitiesPage from '../pages/facilities/page';
import IndustriesPage from '../pages/industries/page';
import AboutPage from '../pages/about/page';
import ExternalRedirect from '../components/ExternalRedirect';
import { BLOG_URL, CAREERS_URL } from '../constants/links';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/technology', element: <TechnologyPage /> },
  { path: '/facilities', element: <FacilitiesPage /> },
  { path: '/industries', element: <IndustriesPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/careers', element: <ExternalRedirect url={CAREERS_URL} /> },
  { path: '/blog', element: <ExternalRedirect url={BLOG_URL} /> },
  { path: '/blog/:slug', element: <ExternalRedirect url={BLOG_URL} /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
